import { request } from "../axios/request";
import * as queryParams from "qs";

import {
  STAFFS_PENDING,
  STAFFS_REJECTED,
  FETCH_STAFFS_FULFILLED,
  ACTIVATE_STAFF_FULFILLED,
  ACTIVATE_STAFF_REJECTED,
  LOGIN_SUCCESS,
  CURRENT_STAFF_FULFILLED,
} from "../constants/staffs";
import { fetchWebUrl } from "./liveCommerceActions/webUrl";
import { getStoreRemoteId } from "utils";
import {
  checkAuthSession,
  removeAuthSession,
  setAuthSession,
} from "theme/utils";
import { logout } from "./auth";

const $A = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/app`);

const $U = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

const $R = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/routes`);

const pending = () => ({
  type: STAFFS_PENDING,
});

const rejected = (error) => ({
  type: STAFFS_REJECTED,
  error: error,
});

const fulfilled = (response) => ({
  type: FETCH_STAFFS_FULFILLED,
  response: response,
});

const currentStaffFulfilled = (response) => ({
  type: CURRENT_STAFF_FULFILLED,
  response: response,
});

const loginSuccess = () => ({
  type: LOGIN_SUCCESS,
});

const activateStaffFulfilled = (response) => ({
  type: ACTIVATE_STAFF_FULFILLED,
  response: response,
});

const activateStaffRejected = (error) => ({
  type: ACTIVATE_STAFF_REJECTED,
  error: error,
});

export const login = (formData) => (dispatch) => {
  dispatch(pending());

  request({
    url: "/retail_stores/login/",
    method: "POST",
    data: queryParams.stringify({
      email: formData.email,
      password: formData.password,
    }),
  })
    .then((response) => {
      dispatch(loginSuccess());
      dispatch(fulfilled(response.data));
      localStorage.setItem("localStaffs", JSON.stringify(response.data));
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};

export const fetchStaffLogin = (formData) => (dispatch) => {
  let responseLanguage = ["TFS"].includes($A.BRAND);
  dispatch(pending());

  request({
    url: $U.LOGIN,
    method: "POST",
    headers: responseLanguage
      ? { "accept-language": "en-US" }
      : { "accept-language": "tr-TR" },
    data: queryParams.stringify({
      email: formData.email,
      password: formData.password,
    }),
  })
    .then((response) => {
      setAuthSession();
      dispatch(loginSuccess());
      if ($R.LIVE_COMMERCE) {
        localStorage.setItem("lc-token", response.data.key);
        dispatch(fetchWebUrl());
      }
      dispatch(fulfilled(response.data));
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};

export const fetchStaffs = () => (dispatch) => {
  let allfetchStaffs = [];
  let paginationCount = 0;
  dispatch(pending());

  request({ url: `${$U.STAFFS}`, method: "get" })
    .then((response) => {
      dispatch(fulfilled(response.data.results));
      paginationCount = response.data.count / 20 + 1;
      allfetchStaffs = [...response.data.results];
      for (let i = 2; i < paginationCount; i++) {
        if (response.data.next !== null) {
          request({
            url: `${$U.STAFFS}?is_active=true&page=${i}`,
            method: "get",
            // eslint-disable-next-line no-loop-func
          }).then((response) => {
            allfetchStaffs = [...allfetchStaffs, ...response.data.results];
            dispatch(fulfilled(allfetchStaffs));
          });
        }
      }
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};

export const activateStaff = (staffId) => (dispatch) => {
  dispatch(pending());
  request({
    url: `/staffs/${staffId}/activate/`,
    method: "POST",
  })
    .then((response) => {
      dispatch(activateStaffFulfilled(response.data));
      dispatch(fetchCurrentStaff());
    })
    .catch((error) => {
      dispatch(activateStaffRejected(error));
    });
};

export const fetchCurrentStaff = () => (dispatch) => {
  const storeRemoteId = getStoreRemoteId();

  dispatch(pending());

  request({
    url: $U.CURRENT_STAFF,
    method: "get",
    params: { current_store_remote_id: storeRemoteId },
  })
    .then((response) => {
      const IS_CHECK_AUTH_BRAND = $A.BRAND === "Koton" || $A.BRAND === "TFS";
      if (IS_CHECK_AUTH_BRAND) {
        const isAuthenticated = checkAuthSession();
        if (!isAuthenticated) {
          dispatch(logout());
        } else {
          setAuthSession();
          dispatch(currentStaffFulfilled(response.data));
        }
      } else {
        dispatch(currentStaffFulfilled(response.data));
      }
    })
    .catch((error) => {
      removeAuthSession();
      dispatch(rejected(error));
      dispatch(logout());
    });
};



// WEBPACK FOOTER //
// ./src/actions/staffs.js